/* global Ad */
import initGeolocationPosition from '@PROJECT_ROOT/assets/shared/js/geolocationPosition';

/**
 * @param {string} errorMessage Poruka pogreške pri geolociranju lokacije
 * @param {string} browserErrorMessage Poruka pogreške browsera (npr. nije dopušteno geolociranje)
 */
export default function initNearMe(errorMessage, browserErrorMessage) {
    const geolocatingErrorMessage = errorMessage;
    const geolocatingBrowserErrorMessage = browserErrorMessage;

    /**
     * Sortiranje je potrebno izbrisati samo ako je po udaljenosti jer takav tip nemamo u ponudi. Ako korisnik promijeni
     * sortiranje po nekom iz ponude, ne želimo ga izbrisati pri uklanjanju filtera 'U blizini'.
     */
    function clearSortIfDistance() {
        const sort = document.getElementById('formSort');
        if (sort.value === 'distance') {
            sort.value = '';
        }
    }

    return {
        setNearMeCoordinates() {
            return new Promise((resolve) => {
                function handleError() {
                    Ad.ToastManager.add('info', geolocatingErrorMessage, 99999, '.toast');
                }

                function handleBrowserError() {
                    Ad.ToastManager.add('info', geolocatingBrowserErrorMessage, 99999, '.toast');
                }

                /**
                 * @param {object} position Objekt koji sadrži koordinate pozicije
                 */
                function handleSuccess(position) {
                    document.getElementById('SearchPrivateFilterForm_nearMe').value = '1';
                    document.getElementById('SearchPrivateFilterForm_coord_lat').value = position.coords.latitude;
                    document.getElementById('SearchPrivateFilterForm_coord_lng').value = position.coords.longitude;
                    document.getElementById('formSort').value = 'distance';

                    resolve(position);
                }

                initGeolocationPosition(handleSuccess, handleError, handleBrowserError);
            });
        },

        /**
         * @return {object|null} Koordinate u float formatu ili null ako bar jedno od njih nije postavljeno
         */
        getNearMeCoordinates() {
            const latitudeFormElement = document.getElementById('SearchPrivateFilterForm_coord_lat');
            const longitudeFormElement = document.getElementById('SearchPrivateFilterForm_coord_lng');

            if (latitudeFormElement.value === '' || longitudeFormElement === '') {
                return null;
            }

            return {
                latitude: parseFloat(latitudeFormElement.value),
                longitude: parseFloat(longitudeFormElement.value),
            };
        },

        clearNearMeCoordinates() {
            document.getElementById('SearchPrivateFilterForm_nearMe').value = '';
            document.getElementById('SearchPrivateFilterForm_coord_lat').value = '';
            document.getElementById('SearchPrivateFilterForm_coord_lng').value = '';
            clearSortIfDistance();
        },
    };
}
